import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({name: 'mpSafeHtml'})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private _sanitized: DomSanitizer) {
    }

    public transform(value: string) {
        return this._sanitized.bypassSecurityTrustHtml(value)
    }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/pipes/safe-html/safe-html.pipe.ts